// Generated from App.tsx for a single page build. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import OurServicesPage from "../pages/OurServices/OurServices";
const __wvcRoutePaths = ["/OurServicesPage"];
function AppRoutes() {
  const location = useLocation();
  return <Routes key={location.pathname}>
            
            
            <Route path={__wvcRoutePaths[0]} element={<OurServicesPage />} />
            
            
            
            
            
            
            
            
            
            
            </Routes>;
}
function App() {
  return <>
            <div className="app">
                <AppRoutes />
            </div>
        </>;
}
export default App;
